import {useEffect, useState} from "react";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.min.css";
import {useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {checkAuth} from "../../Utils/CheckAuthentication";
import {RECENT_VIEW_KEY, TOKEN_KEY} from "../../Utils/Constants";
import {recentlyViewedProducts} from "../../Utils/RecentlyViewed";
import {baseUrl} from "../../shared/baseUrl";
import {createNotification} from "../Common/CreateNotification";
import ItemCard from "../Common/Item/ItemCard";
import SingleItem from "../Common/Item/SingleItem";
import LoadMore from "../Common/LoadMore";
import SectionHead from "../Common/SectionHead";
import ShimmerCard from "../Common/Shimmer/ShimmerCard";
import RecentProducts from "../Home/Recent";
import Login from "../Navbar/Auth/Login";
import Verify from "../Navbar/Auth/Verify";
import "./SingleProduct.css";
import Ad from "../Common/Ad";

const SingleProduct = () => {
  const {pid} = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [isSellerLoading, setIsSellerLoading] = useState(false);
  const [product, setProduct] = useState({});
  const [sellerProducts, setSellerProducts] = useState([]);
  const [images, setImages] = useState([]);
  const [seller, setSeller] = useState({});

  // Login
  const [loginOpen, setLoginOpen] = useState(false);
  const [verifyOpen, setVerifyOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFirst, setIsFirst] = useState(true);
  const [forPagination, setForPagiation] = useState({});
  const [sellerId, setSellerId] = useState(-1);
  const [recentlyViewed, setRecentlyViewed] = useState([]);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    window.scrollTo(0, 0);
    recentlyViewedProducts(pid);

    fetchSingleProduct();
    fetchRecentlyViewedProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pid]);

  const fetchSingleProduct = async () => {
    setIsLoading(true);
    await fetch(baseUrl + `get-product`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: localStorage.getItem(TOKEN_KEY)
          ? "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
          : null,
      },
      body: JSON.stringify({
        id: pid,
      }),
    })
      .then((res) => checkAuth(res))
      .then((res) => {
        if (res.success) {
          setProduct(res.data.product);
          setImages(res.data.product.images);
          if (localStorage.getItem(TOKEN_KEY) !== null) {
            setSeller(res.data.seller);
          }
          setSellerId(res.data.product.added_by);
          fromSameSeller(res.data.product.added_by);
        } else {
          createNotification("error", "Error retriving the product!");
        }
        setIsLoading(false);
      })
      .catch((e) => {
        createNotification("error", "Error retriving the product!");
        setIsLoading(false);
      });
    setIsFirst(false);
  };

  const fromSameSeller = async (seller_id, page = 1, load = false) => {
    setIsSellerLoading(true);
    await fetch(baseUrl + `products-from-seller?page=${page}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: localStorage.getItem(TOKEN_KEY)
          ? "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
          : null,
      },
      body: JSON.stringify({seller_id}),
    })
      .then((res) => checkAuth(res))
      .then((res) => {
        if (res.success) {
          setForPagiation(res.data);
          if (load) {
            setSellerProducts((prevState) => [...prevState, ...res.data.data]);
          } else {
            setSellerProducts(res.data.data);
          }
        } else {
          createNotification("error", "Error retriving the product!");
        }
        setIsSellerLoading(false);
      })
      .catch((e) => {
        setIsSellerLoading(false);
        createNotification("error", "Error retriving the product!");
      });
  };

  const fetchRecentlyViewedProducts = async () => {
    var views = "";
    if (localStorage.getItem(RECENT_VIEW_KEY) !== null) {
      var recentViews = [...JSON.parse(localStorage.getItem(RECENT_VIEW_KEY))];
      recentViews.forEach(
        (element) => (views += encodeURIComponent("views[]") + `=${element}&`)
      );
    } else {
      views += encodeURIComponent("views[]") + "=0";
      console.log(views);
    }

    await fetch(baseUrl + `recently-viewed?${views}`, {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization:
          localStorage.getItem(TOKEN_KEY) !== null
            ? "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
            : null,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setRecentlyViewed(res.data.data.slice(0, 4));
      });
  };

  // const jsonLdData = {
  //   "@context": "http://schema.org",
  //   "@type": "Product",
  //   "productID": `${product.id}`,
  //   "name": `${product.name}`,
  //   "description": "Products - Search for your best matching thrift item according to different category and criteria. Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)",
  //   "url": "https://www.thriftstorenepal.com/",
  //   "image": `${images && images.length > 0 && (Object.values(images[0])[0])}`,
  //   "brand": {
  //     "@type": "Organization",
  //     "name": "Thrift Store Nepal"
  //   },
  //   "offers": {
  //     "@type": "Offer",
  //     "priceCurrency": "NPR",
  //     "price": `${product.price}`,
  //     "availability": "http://schema.org/InStock"
  //   }
  // }
  // console.log("images", Object.values(images[0]));

  return (
    <>
      {/* <Helmet>
        <title>{`${product.name} - Products - Thrift Store Nepa`}l</title>
        <meta
          name=" description"
          content="Products - Search for your best matching thrift item according to different category and criteria. Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)"
        />
        <meta
          property="og:title"
          content={`${product.name} - Products - Thrift Store Nepal`}
        />
        <meta
          property="og:description"
          content="Products - Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - THrift Store Nepal (Thrift Shop Nepal)"
        />
        <meta property="og:image" content={images && images[0] && Object.values(images[0])} />
      </Helmet> */}
      <div className="mt-2 container">
        <div className="d-flex flex-wrap col-12">
          <SingleItem
            fetchSingleProduct={fetchSingleProduct}
            seller={seller}
            isLoading={isLoading}
            product={product}
            images={images}
            setVerifyOpen={setVerifyOpen}
            setLoginOpen={setLoginOpen}
          />
          <div
            className="col-12 col-xl-3 mt-4 mt-xl-0"
            style={{position: "sticky", top: 80}}
          >
            {/* <div className="aio-div p-3 m-2 rounded">
              <div className="aio-div aio-shadow rounded d-flex flex-column-reverse p-3 position-relative">
                <img alt="" src="/assets/images/aio.png" className="aio-logo" />
                <p className="aio-forte">One stop for all your desire.</p>
                <p className="aio-title m-0">All In One</p>
              </div>
            </div> */}
            <Ad />
          </div>
        </div>

        <div className=" mt-4">
          {user ? (
            <SectionHead
              leadFirstLabel="Same"
              leadSecondLabel="Seller"
              trailingFirstLabel="View"
              trailingSecondLabel="All"
              seller={seller}
              onViewPress={() => {
                window.location.href = `/products/userallproducts/${seller.name}/${seller.id}`;
              }}
            />
          ) : (
            <SectionHead leadFirstLabel="Same" leadSecondLabel="Seller" />
          )}
        </div>

        <div className="d-flex flex-wrap mb-5">
          {isSellerLoading && isFirst ? (
            Array(10)
              .fill()
              .map((_, index) => {
                return (
                  <ShimmerCard
                    key={index}
                    clsName="col-6 col-md-4 col-lg-3"
                    index={index}
                  />
                );
              })
          ) : (
            <>
              {sellerProducts &&
                sellerProducts
                  .filter((_, index) => index < 4)
                  .map((product, index) => {
                    return (
                      <ItemCard
                        key={index}
                        item={product}
                        clsName="col-6 col-md-4 col-lg-3 cursor-pointer"
                        index={index}
                      />
                    );
                  })}
              {isSellerLoading &&
                Array(10)
                  .fill()
                  .map((_, index) => {
                    return (
                      <ShimmerCard
                        key={index}
                        clsName="col-6 col-md-4 col-lg-3"
                        index={index}
                      />
                    );
                  })}
              {/* {forPagination.next_page_url &&
                                    <div onClick={() => { setCurrentPage(currentPage + 1); fromSameSeller(sellerId, currentPage + 1); }} style={{ minHeight: 250 }} className="col-6 col-md-4 col-lg-3 cursor-pointer p-2">
                                        <div style={{ borderRadius: "10px" }} className="col-12 bg-white shadow d-flex align-items-center justify-content-center p-2 h-100">
                                            {!isSellerLoading ? <p className="fs-4 fw-bold">Load More</p> :
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                } */}
              <LoadMore
                forPagination={forPagination}
                isLoading={isSellerLoading}
                onClick={() => {
                  setCurrentPage(currentPage + 1);
                  fromSameSeller(sellerId, currentPage + 1, true);
                }}
              />
            </>
          )}
        </div>
        {recentlyViewed && recentlyViewed.length > 0 && (
          <>
            <SectionHead
              onViewPress={() => {}}
              leadFirstLabel="Recently"
              leadSecondLabel="Viewed"
              trailingFirstLabel="View"
              trailingSecondLabel="All"
            />
            <div className="d-flex flex-wrap mb-4">
              {recentlyViewed.map((item, index) => {
                return (
                  <ItemCard
                    key={index}
                    item={item}
                    clsName="col-6 col-md-4 col-lg-3 cursor-pointer"
                    index={index}
                  />
                );
              })}
            </div>
          </>
        )}
        <RecentProducts firstLabel="More" secondLabel="Products" />
      </div>
      <Login
        isOpen={loginOpen}
        onClose={() => {
          setLoginOpen(false);
        }}
      />
      <Verify
        isOpen={verifyOpen}
        onClose={() => {
          setVerifyOpen(false);
        }}
      />
    </>
  );
};

export default SingleProduct;
